import React from "react";
import { useVideoConfig } from "remotion";

export const ZenBackground: React.FC = () => {
  const { width, height } = useVideoConfig();

  const filterId = "zen-paper-noise";
  const clipId = "zen-bg-clip";

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "#fafaf8",
        zIndex: 0,
        overflow: "hidden",
      }}
    >
      {/* SVG layer: noise filter + ink lines + seal mark */}
      <svg
        width={width}
        height={height}
        style={{ position: "absolute", top: 0, left: 0 }}
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <filter id={filterId} x="0%" y="0%" width="100%" height="100%">
            <feTurbulence
              type="fractalNoise"
              baseFrequency="0.65"
              numOctaves="4"
              stitchTiles="stitch"
              result="noiseOut"
            />
            <feColorMatrix
              type="saturate"
              values="0"
              in="noiseOut"
              result="grayNoise"
            />
            <feBlend
              in="SourceGraphic"
              in2="grayNoise"
              mode="multiply"
              result="blended"
            />
            <feComponentTransfer in="blended">
              <feFuncA type="linear" slope="0.03" />
            </feComponentTransfer>
          </filter>
          <clipPath id={clipId}>
            <rect x={0} y={0} width={width} height={height} />
          </clipPath>
        </defs>

        {/* Paper noise overlay */}
        <rect
          x={0}
          y={0}
          width={width}
          height={height}
          fill="#1a1a18"
          filter={`url(#${filterId})`}
          opacity={0.03}
        />

        {/* Horizontal ink line at y:30% */}
        <line
          x1={0}
          y1={height * 0.3}
          x2={width}
          y2={height * 0.3}
          stroke="rgba(26,26,24,0.12)"
          strokeWidth={1}
        />

        {/* Vertical ink line at x:15% */}
        <line
          x1={width * 0.15}
          y1={0}
          x2={width * 0.15}
          y2={height}
          stroke="rgba(26,26,24,0.08)"
          strokeWidth={1}
        />

        {/* Red seal mark — circle, bottom-right area */}
        <circle
          cx={width - 60 - 20} /* right:60px → cx = width - 60 - radius */
          cy={height - 180 - 20} /* bottom:180px → cy = height - 180 - radius */
          r={20}
          fill="#c0392b"
          opacity={0.7}
        />
      </svg>

      {/* Large faded kanji '道' centered */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          pointerEvents: "none",
          zIndex: 1,
        }}
      >
        <span
          style={{
            fontFamily: "'Noto Serif JP', serif",
            fontSize: "400px",
            fontWeight: 400,
            color: "rgba(26,26,24,0.03)",
            lineHeight: 1,
            userSelect: "none",
          }}
        >
          道
        </span>
      </div>
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
